import {
  Home,
  Sparkles,
  FolderKanban,
  LayoutTemplate,
  Palette,
  BookOpen,
  ClipboardList,
  Presentation,
  FileImage,
  BookCopy,
  Rocket,
  Mic,
  Workflow,
  Users,
  Mail,
  MessageSquare,
  BarChart3,
  Plug,
  ShieldCheck,
  Settings as SettingsIcon,
  Shapes,
  Film,
  UserSquare2,
  Megaphone,
  Bot,
  BookText,
  PaintBucket,
} from "lucide-react";

export const SIDEBAR_NAV = [
  {
    section: "Workspaces",
    items: [
      { id: "publish-editor", label: "Publish Editor", to: "/book-lab/editor", icon: BookText },
      { id: "marketing-design", label: "Marketing Design", to: "/marketing-design/editor", icon: PaintBucket },
    ],
  },
  {
    section: "Workspace",
    items: [
      { id: "home", label: "Home", to: "/dashboard", icon: Home },
      { id: "create", label: "Create AI", to: "/create", icon: Sparkles, badge: "AI" },
      { id: "projects", label: "Projects", to: "/projects", icon: FolderKanban },
      { id: "templates", label: "Templates", to: "/templates", icon: LayoutTemplate },
    ],
  },
  {
    section: "Labs",
    items: [
      { id: "brandlab", label: "BrandLab", to: "/brand-lab", icon: Palette },
      { id: "booklab", label: "BookLab", to: "/book-lab", icon: BookOpen },
      { id: "workbooklab", label: "WorkbookLab", to: "/workbook-lab", icon: ClipboardList },
      { id: "slidelab", label: "SlideLab", to: "/slide-lab", icon: Presentation },
      { id: "flyerlab", label: "FlyerLab", to: "/flyer-lab", icon: FileImage },
      { id: "coverlab", label: "CoverLab", to: "/cover-lab", icon: BookCopy },
      { id: "launchlab", label: "LaunchLab", to: "/launch-lab", icon: Rocket },
      { id: "voicelab", label: "VoiceLab", to: "/voice-lab", icon: Mic },
      { id: "logolab", label: "LogoLab", to: "/logo-lab", icon: Shapes },
      { id: "videolab", label: "VideoLab", to: "/video-lab", icon: Film, badge: "NEW" },
      { id: "aiinfluencer", label: "AI Influencer", to: "/ai-influencer", icon: UserSquare2, badge: "NEW" },
      { id: "marketingstudio", label: "Marketing Studio", to: "/marketing-studio", icon: Megaphone, badge: "NEW" },
      { id: "automationlab", label: "AutomationLab", to: "/automation-lab", icon: Workflow },
    ],
  },
  {
    section: "Reach",
    items: [
      { id: "contacts", label: "Contacts", to: "/contacts", icon: Users },
      { id: "email", label: "Email", to: "/email", icon: Mail },
      { id: "sms", label: "SMS", to: "/sms", icon: MessageSquare },
      { id: "analytics", label: "Analytics", to: "/analytics", icon: BarChart3 },
    ],
  },
  {
    section: "System",
    items: [
      { id: "agentai", label: "Agent AI", to: "/agent-ai", icon: Bot, badge: "AI" },
      { id: "integrations", label: "Integrations", to: "/integrations", icon: Plug },
      { id: "settings", label: "Settings", to: "/settings", icon: SettingsIcon },
    ],
  },
];

export const MOBILE_NAV = [
  { id: "home", label: "Home", to: "/dashboard", icon: Home },
  { id: "create", label: "Create", to: "/create", icon: Sparkles },
  { id: "projects", label: "Projects", to: "/projects", icon: FolderKanban },
  { id: "ai", label: "AI", to: "/admin", icon: ShieldCheck, action: "copilot" },
  { id: "more", label: "More", to: "/settings", icon: SettingsIcon },
];

export const QUICK_CREATE = [
  { id: "book", label: "Create Book", icon: BookOpen, to: "/book-lab" },
  { id: "workbook", label: "Create Workbook", icon: ClipboardList, to: "/workbook-lab" },
  { id: "slides", label: "Create Slides", icon: Presentation, to: "/slide-lab" },
  { id: "flyer", label: "Create Flyer", icon: FileImage, to: "/flyer-lab" },
  { id: "campaign", label: "Create Campaign", icon: Rocket, to: "/launch-lab" },
  { id: "upload", label: "Upload Content", icon: Sparkles, to: "/create" },
];
